/* eslint-disable no-param-reassign */
import { useReducer, useCallback, useMemo } from 'react';
import api from '~/services';
import log from '~/helpers/log';

export default function useOutboundNumbers(value = []) {
  function initialState() {
    return {
      numbers: value,
    };
  }

  const outboundNumbers = useCallback((state, action) => {
    switch (action.type) {
      case 'fetch':
        return { numbers: action.payload.numbers };
      case 'update':
        return { ...state };
      case 'reset':
        return [];
      default:
        throw new Error();
    }
  }, []);

  const [state, dispatch] = useReducer(outboundNumbers, initialState());
  const stateMemo = useMemo(() => state, [state]);

  const getOutboundNumbers = useCallback(
    async action => {
      try {
        const outboundData = await api.accounts.get.outboundNumbers();
        if (outboundData.data?.available_numbers) {
          dispatch({
            type: action,
            payload: { numbers: outboundData.data.available_numbers },
          });
        }
      } catch (err) {
        log.error('Failed to fetch outbound numbers.', err);
      }
    },
    [dispatch]
  );

  const updateOutboundNumber = useCallback(
    async (action, param) => {
      try {
        await api.accounts.post.outboundNumberChange(param);
        dispatch({ type: action });
        getOutboundNumbers('fetch');
      } catch (err) {
        log.error('Failed to update outbound number.', err);
      }
    },
    [dispatch, getOutboundNumbers]
  );

  const setOutboundActions = useCallback(
    (action, param) => {
      switch (action) {
        case 'fetch':
          getOutboundNumbers(action);
          break;
        case 'update':
          updateOutboundNumber(action, param);
          break;
        default:
          break;
      }
    },
    [getOutboundNumbers, updateOutboundNumber]
  );

  return [stateMemo, setOutboundActions];
}
